export const RendererType = {
  /**
   * Core renderers
   */
  boolean: 'boolean',
  date: 'date',
  id: 'id',
  multiSelect: 'multiSelect',
  number: 'number',
  singleSelect: 'singleSelect',
  text: 'text',

  /**
   * Fancy renderers
   */
  colorStatus: 'colorStatus',
  colorStatusWithLabel: 'colorStatusWithLabel',
  companyId: 'companyId',
  companySearch: 'companySearch',
  companySocialMedia: 'companySocialMedia',
  companyWebsite: 'companyWebsite',
  currencyId: 'currencyId',
  fileUpload: 'fileUpload',
  fileUpload2: 'fileUpload2',
  formula: 'formula',
  freeLabels: 'freeLabels',
  kpiTable: 'kpiTable',
  location: 'location',
  universalKpiTable: 'universalKpiTable',

  /**
   * @deprecated: Use Renderer=number & configure formatter
   */
  currency: 'currency',
  /**
   * @deprecated: Use Renderer=number & configure formatter
   */
  integer: 'integer',
  /**
   * @deprecated: Use Renderer=number & configure formatter
   */
  multiplier: 'multiplier',
  /**
   * @deprecated: identical to RendererType.number
   */
  numeric: 'numeric',
  /**
   * @deprecated: Use Renderer=number & configure formatter
   */
  percent: 'percent',
  /**
   * @deprecated: Use alternative or customize non-deprecated with fieldSettings config
   */
  fundType: 'fundType',
} as const;

export type RendererType = (typeof RendererType)[keyof typeof RendererType];
